<template lang="pug">
  div
</template>

<script>
import RepositoryFactory from '@/repositories/RepositoryFactory'

const PinRepository = RepositoryFactory.get('pin')

/**
 * 現在のピンの位置によって、表示する一覧を切り替える
 */
const changeList = ($router, pin) => {
  let next = {params: {init: true}}
  if (pin === 'my') {
    next.name = 'box'
  }
  else if (pin === 'all') {
    next.name = 'box-all'
  }
  else if (pin === 'fav') {
    next.name = 'favorite'
  }
  else if (pin === 'acc') {
    next.name = 'browsing'
  }
  $router.push(next)
}

export default {
  name: 'Top',
  beforeCreate () {
    // computed前なのでisMgmtが使えない
    if (this.$store.state.base.u && this.$store.getState('isMgmt')) {
      changeList(this.$router, 'all')
      return
    }

    const defaultList = 'my'

    // computed前なのでisAgentPageが使えない
    if (this.$store.getState('login_user').as_agent) {
      changeList(this.$router, defaultList)
      return
    }

    // 現在のピン位置を取得する
    const vm = this
    PinRepository.get()
      .then(function (response) {
        const data = vm.getApiData(response).data
        changeList(vm.$router, data)
      })
      // エラー時処理
      .catch(function (error) {
        vm.setErrorMessage(error)
        changeList(vm.$router, defaultList)
      })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/top/Index.vue